// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3mnTf","title":"ClientCherryInfo_title__CduTM","itemText":"ClientCherryInfo_itemText__e1OeD"};